module.exports = __webpack_public_path__ + "img/logo-header.18a3e7e5.png";